export default "<ng-container *ngIf='menus'>\n\t<select [innerHtml]='getMenus(menus)'></select>\n</ng-container>";